import styled from "styled-components";

export const ContainerEvento = styled.div`
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  >p{
      font-size: 20px;
  }
`;
